'use client';

import React from 'react';
import { Paper, Title, Text } from '@mantine/core';

export function NotificationCenter() {
  return (
    <Paper shadow="sm" radius="md" p="lg">
      <Title order={4}>Notification Center</Title>
      <Text c="dimmed" size="sm">Full notification center coming soon</Text>
    </Paper>
  );
}